export enum OrderDropshippingPartner {
  Thorne = 'Thorne',
  OpsEngine = 'OpsEngine',
}
